export * from './training.component';



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/training/index.ts